module.exports = __webpack_public_path__ + "img/wz-7-1-6.90a49c44.jpg";